/* created by Athukorala */

import * as actionTypes from '../Action/actionTypes';

const initialState = {
  history: ""
};

const reducer=(state=initialState,action)=>{
  switch(action.type){


    case actionTypes.BROUSER_HISTORY:
      return {
        ...state,
        history: action.value
      };

    default:
      return state;
  }
};

export default reducer;
